/* ═══════════════════════════════════════════════════════════
   TEAM STORE — JavaScript
   assets/team-store.js
   Scroll reveals, tier filtering, nav scroll effect.
   Note: Product page variant/qty/gallery JS is inline in the section.
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    var els = document.querySelectorAll('.ts-reveal:not(.is-visible)');
    if (!els.length || !('IntersectionObserver' in window)) {
      // Fallback: show everything
      els.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── TIER FILTER (Collection Grid) ── */
  function initFilters() {
    var filterBtns = document.querySelectorAll('[data-filter-tier]');
    var products = document.querySelectorAll('[data-product-tier]');
    var countEls = document.querySelectorAll('.ts-filter-count');
    var totalCount = products.length;

    if (!filterBtns.length || !products.length) return;

    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tier = this.dataset.filterTier;

        // Update active states
        filterBtns.forEach(function(b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Filter products
        var visibleCount = 0;
        products.forEach(function(p) {
          if (tier === 'all' || p.dataset.productTier === tier) {
            p.style.display = '';
            visibleCount++;
            // Re-trigger reveal animation
            p.classList.remove('is-visible');
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                p.classList.add('is-visible');
              });
            });
          } else {
            p.style.display = 'none';
          }
        });

        // Update count displays
        var countText = visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');
        countEls.forEach(function(el) { el.textContent = countText; });
      });
    });
  }

  /* ── NAV SCROLL EFFECT ── */
  function initNavScroll() {
    var nav = document.getElementById('team-nav');
    if (!nav) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          if (window.scrollY > 80) {
            nav.style.boxShadow = '0 4px 24px rgba(0,0,0,.12)';
          } else {
            nav.style.boxShadow = 'none';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── INIT ── */
  function init() {
    initReveal();
    initFilters();
    initNavScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();